"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mathSigns = {
    multiplication: '*',
    divisin: '/',
    summation: '+',
    subtraction: '-',
    power: '^',
};
const numRegString = '[+-]?(\\d*\\.?\\d+(e[+-]?\\d+)?|[+-]?Infinity|NaN)';
exports.numberRegExp = new RegExp(`${numRegString}`, 'g');
exports.betweenParenthesesRegExp = new RegExp(`\\(${numRegString}([\\${exports.mathSigns.summation}\\${exports.mathSigns.subtraction}\\${exports.mathSigns.multiplication}\\${exports.mathSigns.divisin}\\${exports.mathSigns.power}]${numRegString})*\\)`, 'g');
exports.divisionRegExp = new RegExp(`\\${exports.mathSigns.divisin}${numRegString}`, 'g');
exports.multiplicationRegExp = new RegExp(`${numRegString}\\${exports.mathSigns.multiplication}${numRegString}`, 'g');
exports.summationOrSubtractionRegExp = new RegExp(`${numRegString}[\\${exports.mathSigns.summation}\\${exports.mathSigns.subtraction}]${numRegString}`, 'g');
exports.powerRegExp = new RegExp(`((?:${numRegString}\\^)+${numRegString})`, 'g');
exports.lastPowerRegExp = new RegExp(`(${numRegString}\\^${numRegString})$`, 'g');
exports.wrongInputRegExp = new RegExp(`^[*/^)]|[-+*\\/^](?!(-|\\+|${numRegString}|\\())|${numRegString}(?=\\()|\\((?=[/*^])`, 'g');
